import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Avatar, Image, List, Pagination, Space, Tag} from "antd";
import {useStore} from "../../store";
import {UserOutlined} from "@ant-design/icons";
import {BaseImageUrl} from "../../http/http";

const cover = require("../../image/public-cover.png");
const defaultIcon = require("../../image/default-pic.png")

const SearchGlobalPublicity:React.FC = () => {
    const {searchGlobal} = useStore();
    const toDetail = (record:any) => {
        window.open(`/home/publicity/detail?id=${record.id}`);
    }

    const onSizeChange = (page: any, pageSize: any) => {
        searchGlobal.sciencePagination.pageSize = pageSize;
        searchGlobal.sciencePagination.pageNum = page;
        searchGlobal.queryGlobal("3", page)
    }

    const renderItem = (item: any) => {
        return <List.Item key={item.key}>
            <ItemWrapper>
                <Image preview={false} defaultValue={defaultIcon} style={{width:"200px", height: "200px", margin: "15px 40px 15px 15px"}} src={item.cover ? BaseImageUrl+item.cover : cover}/>
                <CardWrapper>
                    <TitleSpan onClick={()=>toDetail(item)}>{item.title}</TitleSpan>
                    <Space size={[0, 8]} wrap>
                        {
                            item.category ? item.category.split(',').map((category:string)=> {
                                return <Tag color={"orange"} key={category}>{category}</Tag>
                            }) : ''
                        }
                    </Space>
                    <ContentSpan>
                        {item.description}
                    </ContentSpan>
                    <Space size={[0,10]} style={{marginTop: "15px"}}>
                        {
                            item.userImg ? <Image width={24} style={{borderRadius: '50%'}} src={BaseImageUrl+item.userImg}/> : <Avatar shape="circle" size="small" icon={<UserOutlined />} />
                        }
                        <div style={{cursor:"default", color:"#1990ff", margin: "0 15px"}}>发布人员：{item.creater}</div>
                        <span>来源：{item.source}</span>
                        <span style={{margin: "0 15px"}}>发布时间：{item.createtime}</span>
                    </Space>
                </CardWrapper>
            </ItemWrapper>
        </List.Item>
    }

    return(<Wrapper>
        <List
            style={{overflow:"scroll", background: '#fff'}}
            dataSource={searchGlobal.publicityDataSource}
            renderItem={renderItem}/>
        <Pagination
            size={ "small" }
            style={{ margin: "15px 15px 15px 0", alignSelf: "end" }}
            total={ searchGlobal.sciencePagination.total }
            showQuickJumper={ true }
            showSizeChanger={ false }
            defaultPageSize={ 5 }
            hideOnSinglePage={ true }
            onChange={ onSizeChange }
            current={ searchGlobal.sciencePagination.pageNum }
        />
    </Wrapper>);
}
export default observer(SearchGlobalPublicity);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    .ant-table-wrapper .ant-table-thead >tr>th {
      background: #EFF3F8 ;
    }
    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
  }
`;
const CardWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    padding: 15px;
  }
`;
const CardImg = styled.img`
  & {
    width: 200px;
    height: 200px;
    margin: 15px 40px 15px 40px;

  }
`;

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    color: black;
    cursor: pointer;
  }
`;
const ContentSpan = styled.span`
  & {
    font-size: 14px;
    color: #333333;
    word-break: break-word;
    margin-top: 15px;
  }
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: white;
  border: 1px solid #E7E8EC;
  border-radius: 2px;
  margin: 20px;
  width: 100%;
`;
const CollectionWrapper = styled.div`
  & {
    border-radius: 20px;
    border: 1px solid #d3d3d3;
    padding: 3px 20px;
    color: #d3d3d3;
    background: white;
    font-size: 13px;
    margin-left: 10px;
  }
`;
